import { type BillingOverviewDto } from '../../services/billing.api';
import { billingApi } from '../../services/billing.api';
import { icon } from '../../icons';
import { t } from '../../services/i18n';
import { toastService } from '../../services/toast';
import { esc, renderInvoice } from './profile-shared';

export class RcProfileTabInvoices extends HTMLElement {
  billingOverview: BillingOverviewDto | null = null;
  isLoading = false;
  billingError = '';

  connectedCallback(): void {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback(): void {
    this.removeEventListener('click', this.handleClick);
  }

  render(): void {
    if (this.isLoading) {
      this.innerHTML = `<div class="card profile-card"><div class="empty-state">${t('billing.loading')}</div></div>`;
      return;
    }

    if (this.billingError) {
      this.innerHTML = `<div class="card profile-card"><div class="form-error">${esc(this.billingError)}</div></div>`;
      return;
    }

    const invoices = this.billingOverview?.invoices ?? [];
    if (!invoices.length) {
      this.innerHTML = `
        <div class="card profile-card">
          <div class="empty-state">
            ${icon('file-text', { size: 40, strokeWidth: 1.5, attrs: 'opacity="0.4"' })}
            <p>${t('billing.noInvoices')}</p>
          </div>
        </div>
      `;
      return;
    }

    this.innerHTML = `
      <div class="card profile-card billing-card">
        <div class="profile-section-head">
          <h2>${t('billing.invoiceHistory')}</h2>
          <p>${t('billing.invoiceHelp')}</p>
        </div>
        <div class="billing-invoice-list">
          ${invoices.map((invoice) => renderInvoice(invoice)).join('')}
        </div>
      </div>
    `;
  }

  private handleClick = async (event: Event): Promise<void> => {
    const target = (event.target as HTMLElement | null)?.closest<HTMLElement>('[data-action="download-invoice"]');
    if (!target?.dataset.url) {
      return;
    }

    try {
      await billingApi.downloadInvoice(target.dataset.url, target.dataset.fileName);
    } catch (error) {
      console.error('Failed to download invoice:', error);
      toastService.error(error instanceof Error ? error.message : t('common.errorGeneric'));
    }
  };
}

if (!customElements.get('rc-profile-tab-invoices')) {
  customElements.define('rc-profile-tab-invoices', RcProfileTabInvoices);
}
